import { useState } from 'react'
import PropTypes from 'prop-types'
import tw from 'twin.macro'
import { Link, graphql } from 'gatsby'

import Layout from '../components/layout'
import Meta from '../components/meta'

import BannerCarton from '../components/mineralswim/images/V2-Carton-MineralSwimBagNew.png'
import '../components/mineralswim/Hero/style.css'
import MineralSwimGenerator from '../components/mineralswim/svg/MineralSwimGenerator'
import MineralSwimDeadSeaMinerals from '../components/mineralswim/svg/MineralSwimDeadSeaMinerals'
import MineralSwimPhBalancerModule from '../components/mineralswim/svg/MineralSwimPhBalancerModule'
import MineralSwimPurifier from '../components/mineralswim/svg/MineralSwimPurifier'
import { SwiperComponent } from '../components/mineralswim/Swiper/SwiperComponent'
import { testimonials } from '../components/mineralswim/data/testimonial'
import { AccordionIndex } from '../components/mineralswim/Accordion/AccordionIndex'
import steps from '../components/mineralswim/data/steps'
import CartonX3 from '../components/mineralswim/images/V2-Cartons-Purifier&Pro.png'
import NewPool from '../components/mineralswim/images/@Domain-Pools-Australia_1.jpg'
import EliteLogo from '../components/mineralswim/svg/EliteLogo'
import EliteBuilderLogo from '../components/mineralswim/svg/EliteBuilderLogo'
import ExistingPool from '../components/mineralswim/images/@Mineral-Pool-QLD_1.jpg'
import BrochureForm from '../components/mineralswim/BrochureForm/BrochureForm'

const MineralSwimPage = props => {
	const { pageData } = props.data
	const {
		seoTitle,
		seoKeywords,
		seoDescription,
		node_locale,
		slug,
	} = pageData.edges[0].node

	const [isFormModalOpen, setIsFormModalOpen] = useState(false)
	const { step1, step2, step3 } = steps
	return (
		<Layout>
			<Meta
				title={seoTitle}
				description={seoDescription}
				keywords={seoKeywords}
				lang={node_locale}
				slug={slug}
			/>
			<main css={tw`w-screen overflow-hidden font-sans -mt-8 leading-6`}>
				{/* DOWNLOAD BROCHURE MODAL */}
				{isFormModalOpen && (
					<div
						style={{ backgroundColor: 'rgba(0, 0, 0, 0.5)', zIndex: '999999' }}
						css={tw`fixed inset-0 w-full h-full flex justify-center items-center`}
					>
						<div css={tw`backdrop-blur-lg bg-white p-5 rounded-md mx-5`}>
							<BrochureForm setIsFormModalOpen={setIsFormModalOpen} />
						</div>
					</div>
				)}

				<section
					className="banner-background-image"
					css={tw`w-full bg-cover bg-center relative mb-16 xs:mb-0`}
				>
					{/* HERO BANNER */}
					<div
						css={tw`max-w-screen-lg grid lg:grid-cols-12 mx-auto 2xl:pl-0 xl:pl-36 lg:pl-36 text-white h-full`}
					>
						<div
							css={tw`lg:col-span-6 flex flex-col gap-10 lg:gap-10 pt-5 pb-16 md:pt-0 lg:py-0 justify-around lg:justify-center h-full text-center lg:text-left`}
						>
							<div
								css={tw`text-2xl leading-tight pb-28 md:pb-48 lg:pb-0 xs:text-4xl`}
							>
								<h1>
									MINERAL SWIM&trade;
									<br />
									<span css={tw`-mt-1 md:-mt-3`}>BY MAYTRONICS</span>
								</h1>
								<p
									css={tw`leading-tight text-xs uppercase pb-10 lg:pb-0 xs:text-base`}
								>
									Natural Purification from the Dead Sea
								</p>
							</div>

							<div
								css={tw`text-2xs flex flex-col gap-2 justify-center items-center lg:justify-start lg:items-start`}
							>
								<p
									css={tw`leading-4 sm:leading-6 md:w-4/5 text-xs md:text-xl lg:mb-10 xs:text-base`}
								>
									Experience the healing and
									<br /> skin-softening benefits of a <br />
									Dead Sea Mineral Swim&trade; Pool.
								</p>
								<Link
									to="https://www.maytronics.com.au/en-ZA/mineral-swim/shop"
									css={tw`cursor-pointer text-center w-64 md:w-72 text-sm sm:text-base bg-white text-black rounded-md py-1 font-bold hover:text-white hover:bg-gray-800 uppercase`}
								>
									Find the Right System
								</Link>
							</div>
							<div
								css={tw`hidden w-full lg:w-screen lg:px-5 lg:flex flex-col items-center mb-16 lg:mb-0`}
							></div>
						</div>
					</div>
				</section>
				<section
					css={tw`xs:flex hidden w-full justify-center items-center z-10 -mt-20 md:-mt-32 lg:-mt-36 relative mb-16 md:mb-20 lg:mb-0`}
				>
					<img
						src={BannerCarton}
						alt="Mineral V2 Product"
						css={tw`object-contain object-center h-40 md:h-64 relative z-20`}
					/>
				</section>

				<div
					css={tw`relative bg-white flex flex-col justify-center items-center md:pt-5 md:pb-16`}
				>
					<section css={tw`w-full px-4 text-gray-800 sm:px-6 lg:px-8`}>
						<div
							css={tw`flex flex-col md:flex-row max-w-screen-lg mx-auto text-center`}
						>
							<div
								css={tw`flex flex-col justify-center items-center w-full text-lg mb-4 md:mb-0`}
							>
								<h2
									css={tw`text-2xl sm:text-3xl font-extrabold md:font-medium uppercase text-blue-500 leading-9`}
								>
									<span>
										WHAT IS THE MINERAL SWIM&trade; PURIFICATION SYSTEM?
									</span>
								</h2>
								<p css={tw`text-sm mt-5 leading-6`}>
									For thousands of years, the Dead Sea has attracted visitors
									worldwide who want to enjoy the mineral-rich water's health
									and well-being benefits. <br />
									Now, you can experience the remarkable benefits of the Dead
									Sea in your pool with the Maytronics Mineral Pool Purification
									System. Designed specifically for Australian pools, it
									combines ozone–to–oxygen purification technology and 100% Dead
									Sea Minerals to create a crystal-clear, therapeutic swimming
									experience for your backyard pool like no other.
								</p>
							</div>
						</div>

						<div css={tw`text-gray-600`}>
							<div
								css={tw`max-w-7xl pt-12 px-4 text-center sm:px-6 lg:px-8 mx-auto`}
							>
								<div css={tw`space-y-8 sm:space-y-12`}>
									<ul
										css={tw`mx-auto grid grid-cols-2 gap-x-16 gap-y-8 md:gap-x-5 lg:max-w-5xl lg:gap-x-8 lg:gap-y-12 md:grid-cols-4 text-xs text-gray-700 pb-16 md:pb-0`}
									>
										<li css={tw`px-2 flex flex-col justify-start items-center`}>
											<div
												css={tw`transform transition duration-500 hover:scale-110`}
											>
												<MineralSwimPurifier css={tw`mx-auto h-24 xs:h-32`} />
											</div>
										</li>
										<li css={tw`px-2 flex flex-col justify-start items-center`}>
											<div
												css={tw`transform transition duration-500 hover:scale-110`}
											>
												<MineralSwimGenerator css={tw`mx-auto h-24 xs:h-32`} />
											</div>
										</li>
										<li css={tw`px-2 flex flex-col justify-start items-center`}>
											<div
												css={tw`transform transition duration-500 hover:scale-110`}
											>
												<MineralSwimDeadSeaMinerals
													css={tw`mt-1 mx-auto h-24 xs:h-32`}
												/>
											</div>
										</li>
										<li css={tw`px-2 flex flex-col justify-start items-center`}>
											<div
												css={tw`transform transition duration-500 hover:scale-110`}
											>
												<MineralSwimPhBalancerModule
													css={tw`mt-1 mx-auto h-24 xs:h-32`}
												/>
											</div>
										</li>
									</ul>
								</div>
							</div>
						</div>
					</section>
				</div>

				<section
					className="banner-purification"
					css={tw`w-full bg-cover bg-center font-sans mb-1`}
				>
					<div
						css={tw`max-w-screen-lg mx-auto h-full px-10 text-white flex w-full justify-end items-center lg:grid grid-cols-2 pb-10 md:pb-16`}
					>
						<div
							id="how-it-works"
							css={tw`flex flex-col justify-end lg:justify-center items-start lg:items-center w-full h-full`}
						>
							<div css={tw`xs:text-3xl text-base md:text-4xl leading-tight`}>
								<h2>
									HOW DOES
									<br /> MINERAL SWIM&trade;
									<br /> PURIFICATION
									<br /> WORK?
								</h2>
							</div>
						</div>
					</div>
				</section>

				<section
					css={tw`relative w-full bg-gray-800 pt-12 pb-20 md:pt-20 px-8 text-white sm:px-6 lg:px-8 lg:py-24`}
				>
					<div
						css={tw`grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3 max-w-screen-lg mx-auto`}
					>
						<div
							css={tw`space-y-6 text-lg mb-4 md:mb-0 md:mr-4 font-sans px-1 w-full`}
						>
							<div css={tw`leading-tight`}>
								<h3 css={tw`font-extrabold text-base uppercase`}>
									DEAD SEA MINERALS
								</h3>
							</div>
							<p tw="text-sm md:h-40 overflow-auto">
								Dead Sea minerals have been renowned for their therapeutic
								benefits for thousands of years. Our minerals are sourced
								directly from the Dead Sea, a hypersaline lake in Israel with
								unique magnesium-rich mineral properties that offer a range of
								health, skin, and wellness benefits.
							</p>
							<div css={tw`px-3 md:px-0 text-sm`}>
								<AccordionIndex
									items={step1}
									backGroundColor={'bg-blue-500'}
									activeBackGroundColor={'bg-white'}
								/>
							</div>
						</div>
						<div
							css={tw`mt-14 md:mt-0 flex flex-col space-y-6 text-lg mb-4 md:mb-0 md:mr-4 font-sans px-1`}
						>
							<div css={tw`leading-tight`}>
								<h3 css={tw`font-extrabold text-base uppercase`}>
									OZONE PURIFICATION
								</h3>
							</div>
							<p tw="text-sm md:h-40 overflow-auto">
								Oxygen is converted to Ozone, which neutralises harmful
								contaminants in your pool. Combined with Mineral Swim&trade;
								100% Dead Sea minerals, the purification system turns your pool
								into a crystal-clear, odour-free swimming experience.
							</p>
							<div css={tw`px-3 md:px-0 text-sm`}>
								<AccordionIndex
									items={step3}
									backGroundColor={'bg-blue-500'}
									activeBackGroundColor={'bg-white'}
								/>
							</div>
						</div>
						<div
							css={tw`mt-14 lg:mt-0 flex flex-col space-y-6 text-lg mb-4 md:mb-0 md:mr-4 font-sans px-1`}
						>
							<div css={tw`leading-tight`}>
								<h3 css={tw`font-extrabold text-base uppercase`}>
									MINERAL SWIM OPTIMISATIONS
								</h3>
							</div>
							<p tw="text-sm md:h-40 overflow-auto">
								Enhance your Mineral Swim&trade; experience with optional
								upgrades and streamline your pool maintenance routine with
								Maytronics. Your Mineral Swim&trade; System delivers top-tier
								pool sanitation. Explore easy upgrades and enjoy these
								optimisations:
							</p>
							<div css={tw`px-3 md:px-0 text-sm`}>
								<AccordionIndex
									items={step2}
									backGroundColor={'bg-blue-500'}
									activeBackGroundColor={'bg-white'}
								/>
							</div>
						</div>
					</div>
				</section>

				<section
					css={tw`w-full py-12 px-4 text-gray-800 sm:px-6 lg:px-8 relative`}
				>
					<div
						css={tw`flex flex-col md:flex-row max-w-screen-lg mx-auto text-center`}
					>
						<div
							css={tw`flex flex-col justify-center items-center w-full text-lg mb-4 md:mb-0 font-sans gap-10`}
						>
							<div>
								<h2
									css={tw`text-2xl sm:text-4xl font-sans font-extrabold md:font-medium uppercase text-blue-500 leading-9`}
								>
									<span>EXPLORE THE RIGHT MINERAL POOL SYSTEM FOR YOU</span>
								</h2>
								<p css={tw`mt-5 text-sm font-medium mb-3`}>
									Whether you seek ultimate relaxation, easy pool maintenance,
									or a therapeutic mineral swimming experience, our Mineral
									Swim&trade; range offers a solution.
								</p>
								<p css={tw`text-sm font-medium`}>
									Designed and made in Australia for Australian pools, our
									Mineral Swim&trade; range blends the latest advanced
									technology of mineral pool systems with the natural benefits
									of Dead Sea minerals. Explore our range to discover how your
									pool can be transformed into a sanctuary of health and
									wellness.
								</p>
							</div>
							<div>
								<Link
									to="https://www.maytronics.com.au/en-ZA/mineral-swim/shop"
									css={tw`border text-base text-blue-500 border-blue-500 rounded-md py-2 px-8 font-bold hover:text-blue-300 hover:bg-blue-500`}
								>
									FIND THE RIGHT SYSTEM
								</Link>
							</div>
							<div
								ccss={tw`w-full flex justify-center items-center md:-mt-3 -mb-10`}
							>
								<img
									src={CartonX3}
									alt="Mineral V2 Product"
									css={tw`object-contain object-center h-56 md:h-80`}
								/>
							</div>
						</div>
					</div>
				</section>

				<div css={tw`mx-auto max-w-screen-lg`}>
					<hr
						css={tw`mx-5`}
						style={{
							height: '1px',
							border: 'none',
							backgroundImage: 'linear-gradient(to right, white, gray, white)',
						}}
					/>
				</div>

				<div css={tw`w-full`}>
					<section
						id="existing-pool"
						css={tw`max-w-screen-lg mx-auto pt-10 md:py-20 text-center md:text-left`}
					>
						<div
							css={tw`text-blue-500 h-full grid md:grid-cols-2 px-10 md:px-5 lg:px-0`}
						>
							<div css={tw`h-70vh md:h-full flex justify-center items-center`}>
								<div
									css={tw`h-full md:px-5 flex-grow flex items-center justify-center mb-10 md:mb-0`}
								>
									<img
										src={ExistingPool}
										alt="Mineral Swim Elite Builder House"
										css={tw`h-full w-auto object-cover rounded-xl`}
									/>
								</div>
							</div>
							<div
								css={tw`flex flex-col justify-center items-center md:justify-start md:items-start lg:pb-10 md:pb-0 pb-10 text-2xl gap-10 md:gap-10 md:pl-2 lg:pl-5 pr-0 md:pr-5 lg:pr-0`}
							>
								<h2 css={tw`text-3xl md:text-4xl leading-tight`}>
									CONVERT TO A MINERAL POOL WITH MINERAL SWIM&trade;
								</h2>
								<p css={tw`text-gray-800 text-sm`}>
									Transform your pool effortlessly. The Mineral Swim&trade; V2
									Purifier seamlessly integrates with any existing pool
									sanitation system and can be controlled by your existing
									chlorinator. Opt for a Mineral Swim&trade; PRO system for a
									full mineral pool system upgrade with no additional
									chlorinator required. Consult your local Maytronics Elite
									Dealer for expert advice on the perfect fit and enhance your
									experience with 100% Dead Sea Minerals.
								</p>
								<div>
									<Link
										to="/en-ZA/support/find-a-dealer/"
										css={tw`border-2 text-base text-blue-500 border-blue-500 rounded-md py-3 px-7 font-bold hover:text-blue-300 hover:bg-blue-500`}
									>
										FIND A SUPPLIER
									</Link>
								</div>
								<div>
									<EliteLogo css={tw`h-20 lg:mb-16`} color={'black'} />
								</div>
							</div>
						</div>
					</section>
				</div>

				<div css={tw`mx-auto max-w-screen-lg`}>
					<hr
						css={tw`mx-5`}
						style={{
							height: '1px',
							border: 'none',
							backgroundImage: 'linear-gradient(to right, white, gray, white)',
						}}
					/>
				</div>

				<section css={tw`w-full bg-white text-gray-800 py-10 md:py-20`}>
					<div
						css={tw`w-full flex flex-col md:flex-row text-base text-center gap-10 md:gap-0`}
					>
						<div
							css={tw`flex-grow flex flex-row items-center justify-center md:border-r border-gray-400`}
						>
							<img
								src="https://images.ctfassets.net/ftcnv5up9dxv/3AlSWQxulzdASQFU6EV1mj/b9ec16e0742705682329b7c9dac35479/mineral-swim-brand.png"
								alt="Mineral Swim 'LS' Brand Icon"
								css={tw`w-20 object-contain`}
							/>{' '}
							<h2
								css={tw`text-xl md:text-3xl font-sans font-extrabold md:font-medium uppercase text-blue-500 leading-tight text-left`}
							>
								TRUSTED BY COMPANIES.
								<br /> LOVED BY SWIMMERS!
							</h2>
						</div>
						<div
							css={tw`flex-grow flex flex-col justify-center h-full md:border-r gap-2 border-gray-400`}
						>
							<h3
								css={tw`font-sans text-dolphin-gray text-base whitespace-nowrap px-4`}
							>
								FEATURED ON
							</h3>
							<h4 css={tw`font-sans text-blue-500 text-2xl uppercase`}>
								The Block
							</h4>
							<small>(Channel 9)</small>
						</div>
						<div
							css={tw`flex-grow flex flex-col justify-center h-full md:border-r gap-2 border-gray-400`}
						>
							<h3
								css={tw`font-sans text-dolphin-gray text-base whitespace-nowrap px-4`}
							>
								FEATURED ON
							</h3>
							<h4 css={tw`font-sans text-blue-500 text-2xl uppercase`}>
								Healthy Homes
							</h4>
							<small>(Channel 10)</small>
						</div>
						<div css={tw`flex-grow flex flex-col justify-center gap-2 h-full`}>
							<h3
								css={tw`font-sans text-dolphin-gray text-base whitespace-nowrap`}
							>
								FEATURED ON
							</h3>
							<h4 css={tw`font-sans text-blue-500 text-2xl uppercase`}>
								Three Birds Renovations
							</h4>
							<small>(YouTube)</small>
						</div>
					</div>
				</section>

				<section id="testimonials" css={tw`bg-gray-800 flex flex-col`}>
					<div css={tw`shadow-2xl py-10 md:py-16 lg:px-0 px-5 md:px-3`}>
						<h2
							css={tw`text-center text-2xl sm:text-4xl font-extrabold md:font-medium uppercase text-blue-500 mb-5 md:mb-10`}
						>
							TESTIMONIALS
						</h2>
						<div
							className="main-swiper-container"
							css={tw`max-w-screen-lg mx-auto text-white md:-ml-2 lg:mx-auto`}
						>
							<SwiperComponent data={testimonials} />
						</div>
					</div>
				</section>

				<section css={tw`w-full text-blue-500 py-20 text-center space-y-10`}>
					<h2 css={tw`text-3xl mb-5 leading-10`}>
						LET’S START YOUR
						<br /> MINERAL SWIM&trade; JOURNEY
					</h2>
					<div
						css={tw`max-w-screen-lg mx-auto flex flex-col md:flex-row justify-center items-center px-5 md:px-2 lg:px-5 gap-5 md:gap-3 lg:gap-5`}
					>
						<div
							onClick={() => {
								setIsFormModalOpen(true)
							}}
						>
							<button
								css={tw`text-lg md:text-base lg:text-base text-white rounded-md py-3 px-7 md:px-4 lg:py-3 lg:px-7 font-semibold bg-gray-900 hover:text-blue-300 hover:bg-blue-500`}
							>
								DOWNLOAD A BROCHURE
							</button>
						</div>
						<Link
							to="/en-ZA/support/find-a-dealer/"
							css={tw`text-lg md:text-base lg:text-base text-white rounded-md py-3 px-7 md:px-4 lg:py-3 lg:px-7  font-semibold bg-gray-900 hover:text-blue-300 hover:bg-blue-500`}
						>
							FIND A NEARBY SUPPLIER
						</Link>

						<Link
							to="https://www.maytronics.com.au/en-ZA/mineral-swim/shop"
							css={tw`text-lg md:text-base lg:text-base text-white rounded-md py-3 px-7 md:px-4 lg:py-3 lg:px-7  font-semibold bg-gray-900 hover:text-blue-300 hover:bg-blue-500`}
						>
							FIND THE RIGHT PACKAGE
						</Link>
					</div>
				</section>
			</main>
		</Layout>
	)
}

export const MineralSwimPageQuery = graphql`
	query mineralSwimPageQueryZA {
		pageData: allContentfulPage(
			filter: {
				contentful_id: { eq: "oM4c5WvwohIH0cRDqBQa4" }
				node_locale: { eq: "en-AU" }
			}
		) {
			edges {
				node {
					seoTitle
					seoKeywords
					seoDescription
					node_locale
					slug
					body {
						json
					}
				}
			}
		}
		slideData: allContentfulBanner(
			filter: {
				identifier: { regex: "/slide-mineral-swim-/" }
				node_locale: { eq: "en-AU" }
			}
			sort: { fields: identifier, order: ASC }
		) {
			edges {
				node {
					hook
					backgroundImage {
						title
						alt: description
						fluid(maxWidth: 1600, quality: 80) {
							...GatsbyContentfulFluid_withWebp
						}
					}
					objectPosition: background
					mainActionText
					mainActionUrl
					secondActionText
					secondActionUrl
					thirdActionText
					downloads {
						file {
							url
						}
					}
				}
			}
		}
		ozonePlusMineralsImage: allContentfulAsset(
			filter: {
				contentful_id: { eq: "1bywitGSiAX7ya8NIX7cGr" }
				node_locale: { eq: "en-AU" }
			}
		) {
			nodes {
				title
				alt: description
				fixed(width: 250, quality: 65) {
					...GatsbyContentfulFixed_withWebp
				}
			}
		}
		testimonyImage: allContentfulAsset(
			filter: {
				contentful_id: { eq: "3g0bX3OWHQ38nGTX7EW6nZ" }
				node_locale: { eq: "en-AU" }
			}
		) {
			nodes {
				title
				alt: description
				fluid(maxWidth: 1600, maxHeight: 900, quality: 70) {
					...GatsbyContentfulFluid_withWebp
				}
			}
		}
		environmentImage: allContentfulAsset(
			filter: {
				contentful_id: { eq: "5xkrjj9wx0IwvqS5eKjyAz" }
				node_locale: { eq: "en-AU" }
			}
		) {
			nodes {
				title
				alt: description
				fluid(maxWidth: 1600, maxHeight: 900, quality: 70) {
					...GatsbyContentfulFluid_withWebp
				}
			}
		}
		customerCareImage: allContentfulAsset(
			filter: {
				contentful_id: { eq: "7eG1exbHxwcz5duqWf5AGQ" }
				node_locale: { eq: "en-AU" }
			}
		) {
			nodes {
				title
				alt: description
				fluid(maxWidth: 1600, maxHeight: 900, quality: 70) {
					...GatsbyContentfulFluid_withWebp
				}
			}
		}
		systemDiagramImage: allContentfulAsset(
			filter: {
				contentful_id: { eq: "Z0wrBpkLpa5F1ojZl0pTh" }
				node_locale: { eq: "en-AU" }
			}
		) {
			nodes {
				title
				alt: description
				fluid(maxWidth: 1600, maxHeight: 900, quality: 80) {
					...GatsbyContentfulFluid_withWebp
				}
			}
		}
		systemComparisonImage: allContentfulAsset(
			filter: {
				contentful_id: { eq: "62DBO9BJm8q4KFH6S3fPgZ" }
				node_locale: { eq: "en-AU" }
			}
		) {
			nodes {
				title
				alt: description
				fluid(maxWidth: 1280, quality: 80) {
					...GatsbyContentfulFluid_withWebp
				}
			}
		}
		howItWorks3000xImage: allContentfulAsset(
			filter: {
				contentful_id: { eq: "qoCJaQtgEThV5XI5WAI6t" }
				node_locale: { eq: "en-AU" }
			}
		) {
			nodes {
				title
				alt: description
				fluid(maxWidth: 300, maxHeight: 300, quality: 80) {
					...GatsbyContentfulFluid_withWebp
				}
			}
		}
		howItWorksStepsImage: allContentfulAsset(
			filter: {
				contentful_id: { eq: "3qqNdHhj1eci6lfmzFbohB" }
				node_locale: { eq: "en-AU" }
			}
		) {
			nodes {
				title
				alt: description
				fluid(maxWidth: 375, maxHeight: 370, quality: 80) {
					...GatsbyContentfulFluid_withWebp
				}
			}
		}
		howItWorks80Image: allContentfulAsset(
			filter: {
				contentful_id: { eq: "2ONUUbuAkMdSm1E0L1GZ1S" }
				node_locale: { eq: "en-AU" }
			}
		) {
			nodes {
				title
				alt: description
				fluid(maxWidth: 300, maxHeight: 300, quality: 80) {
					...GatsbyContentfulFluid_withWebp
				}
			}
		}
		systemDiagramMobileImage: allContentfulAsset(
			filter: {
				contentful_id: { eq: "Z0wrBpkLpa5F1ojZl0pTh" }
				node_locale: { eq: "en-AU" }
			}
		) {
			nodes {
				title
				alt: description
				fluid(maxWidth: 900, maxHeight: 800, quality: 80) {
					...GatsbyContentfulFluid_withWebp
				}
			}
		}
		systemImage: allContentfulAsset(
			filter: {
				contentful_id: { eq: "2J00c5KA4b1QUa0458eIYV" }
				node_locale: { eq: "en-AU" }
			}
		) {
			nodes {
				title
				alt: description
				fluid(maxWidth: 300, maxHeight: 250, quality: 70) {
					...GatsbyContentfulFluid_withWebp
				}
			}
		}
		mineralsImage: allContentfulAsset(
			filter: {
				contentful_id: { eq: "5sQO2IdeAD0AiK8ZPWjEPb" }
				node_locale: { eq: "en-AU" }
			}
		) {
			nodes {
				title
				alt: description
				fluid(maxWidth: 300, maxHeight: 250, quality: 70) {
					...GatsbyContentfulFluid_withWebp
				}
			}
		}
		phControlImage: allContentfulAsset(
			filter: {
				contentful_id: { eq: "6E45H09MFZoTCxpSmh30wQ" }
				node_locale: { eq: "en-AU" }
			}
		) {
			nodes {
				title
				alt: description
				fluid(maxWidth: 300, maxHeight: 250, quality: 70) {
					...GatsbyContentfulFluid_withWebp
				}
			}
		}
		cleanerImage: allContentfulAsset(
			filter: {
				contentful_id: { eq: "4JPYUN2nsnGDmINK5gIGLn" }
				node_locale: { eq: "en-AU" }
			}
		) {
			nodes {
				title
				alt: description
				fluid(maxWidth: 300, maxHeight: 250, quality: 70) {
					...GatsbyContentfulFluid_withWebp
				}
			}
		}
		formData: allContentfulForm(
			filter: {
				contentful_id: { eq: "6UMqPZWkL51tUSj47XCQEJ" }
				node_locale: { eq: "en-AU" }
			}
		) {
			edges {
				node {
					title
					description
					endpoint
					node_locale
					items {
						... on ContentfulFormField {
							helpText
							inputAutocomplete
							inputId
							inputName
							inputPlaceholder
							inputRequired
							inputType
							textareaCols
							textareaRows
							icon
							validationText
							width
							options
							node_locale
							label
						}
						... on ContentfulFormGroup {
							title
							items {
								width
								validationText
								textareaRows
								textareaCols
								options
								node_locale
								label
								inputType
								inputRequired
								inputPlaceholder
								inputName
								inputId
								inputAutocomplete
								icon
								helpText
							}
						}
					}
				}
			}
		}
	}
`

export default MineralSwimPage

MineralSwimPage.propTypes = {
	data: PropTypes.shape({
		pageData: PropTypes.objectOf(PropTypes.array),
		slideData: PropTypes.objectOf(PropTypes.array),
		ozonePlusMineralsImage: PropTypes.object,
		systemImage: PropTypes.object,
		cleanerImage: PropTypes.object,
		mineralsImage: PropTypes.object,
		phControlImage: PropTypes.object,
		testimonyImage: PropTypes.object,
		environmentImage: PropTypes.object,
		formData: PropTypes.object,
		systemComparisonImage: PropTypes.object,
		howItWorks3000xImage: PropTypes.object,
		howItWorksStepsImage: PropTypes.object,
		howItWorks80Image: PropTypes.object,
		systemDiagramImage: PropTypes.object,
		customerCareImage: PropTypes.object,
	}),
	location: PropTypes.shape({
		search: PropTypes.string,
	}),
}
